import * as React from "react";
import { LineChart } from "@mui/x-charts/LineChart";
import { CartesianGrid, XAxis, YAxis, Tooltip, Legend, Line } from "recharts";
import { Box, Typography } from "@mui/material";
import { AdvancedRealTimeChart } from "react-ts-tradingview-widgets";
// import { generateChartData } from "@mui/x-charts/generators";

const dateFormatter = Intl.DateTimeFormat(undefined, {
	month: "2-digit",
	day: "2-digit",
});
const oneDay = 24 * 60 * 60 * 1000; // in milliseconds

const length = 16;
const firstDataSeed = randBetween(0, 5000);
const secondDataSeed = randBetween(0, 5000);
const initialFirstData = Array.from({ length }).map(
	(_, __, array) => (array.at(-1) ?? firstDataSeed) + randBetween(-500, 500)
);
const initialSecondData = Array.from({ length }).map(
	(_, __, array) => (array.at(-1) ?? secondDataSeed) + randBetween(-500, 500)
);

export default function TradeUtil() {
	const [date, setDate] = React.useState(new Date(2000, 0, 0));
	const [firstData, setFirstData] = React.useState(initialFirstData);
	const [secondData, setSecondData] = React.useState(initialSecondData);

	React.useEffect(() => {
		const intervalId = setInterval(() => {
			setDate((prev) => new Date(prev.getTime() + oneDay));
			setFirstData((prev) => [
				...prev.slice(1),
				prev.at(-1) + randBetween(-500, 500),
			]);
			setSecondData((prev) => [
				...prev.slice(1),
				prev.at(-1) + randBetween(-500, 500),
			]);
		}, 1000);

		return () => {
			clearInterval(intervalId);
		};
	}, []);

	return (
		<Box sx={{ width: "100%", typography: "body1", background: "green" }}>
			<Box
				variant="section"
				className="w-[98%]  h-[25rem] mx-auto my-2  bg-red-500">
				<AdvancedRealTimeChart
					autosize={true}
					width="100%"
					symbol="INDEX:BTCUSD"
					timezone={"Etc/UTC"}
					theme="dark"
					style={1}
					locale="en"
					withdateranges={true}
					range="ALL"
					hide_side_toolbar={false}
					allow_symbol_change={true}
					details={true}
					hotlist={true}
					show_popup_button={true}
					popup_width="1000"
					popup_height="650"

					// "support_host="https://www.tradingview.com"
				/>
			</Box>
			<Typography variant="h6">
				{" "}
				<span className="text-blue-400">Bid</span> &{" "}
				<span className="text-[#227b8d]">Ask</span> Overview{" "}
			</Typography>

			<LineChart
				height={300}
				series={[{ data: secondData }, { data: firstData }]}
				xAxis={[
					{
						scaleType: "point",
						data: Array.from({ length }).map(
							(_, i) => new Date(date.getTime() + i * oneDay)
						),
						valueFormatter: (value) => dateFormatter.format(value),
					},
				]}
				yAxis={[{ width: 50 }]}
				margin={{ right: 24 }}>
				{/* <Tooltip /> */}
				{/* <Legend /> */}
				<Line
					type="monotone"
					dataKey="first"
					stroke="#775144"
					strokeWidth={2}
				/>
				<Line
					type="monotone"
					dataKey="second"
					stroke="#82ca9d"
					strokeWidth={2}
				/>
			</LineChart>
		</Box>
	);
}

function randBetween(min, max) {
	return Math.floor(Math.random() * (max - min + 1) + min);
}
